import {actionTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = actionTypes;

const path = `iot/action`;

const base = new BaseAction(types);

export const getActionDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedActionDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getActionData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedActionData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addActionData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editActionData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteActionData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreActionData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteActionData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
